export default __webpack_public_path__ + "static/media/informacion.9d21a3c6.svg";